module.exports = __webpack_public_path__ + "static/media/right-arrow.a27cc840.svg";